exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes src-components-styles-components-___loading__spin___3biPD{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.src-components-styles-components-___loading__spinnerDark___2888d{border-radius:50%!important;width:5em;height:5em;margin:0 auto;font-size:10px;position:relative;text-indent:-9999em;border:.3em solid rgba(85,85,85,.2);border-left-color:#555;transform:translateZ(0);animation:src-components-styles-components-___loading__spin___3biPD 1.1s infinite linear}.src-components-styles-components-___loading__spinnerDark___2888d.src-components-styles-components-___loading__loader___1g3na,.src-components-styles-components-___loading__spinnerDark___2888d.src-components-styles-components-___loading__loader___1g3na:after{border-radius:50%!important;width:5em;height:5em}.src-components-styles-components-___loading__loadingPanel___3ji8U{z-index:99999;height:100%;width:100%;position:absolute;right:0;top:0;display:flex;justify-content:center;align-items:center;background-color:hsla(0,0%,100%,.8)}", ""]);

// exports
exports.locals = {
	"spinnerDark": "src-components-styles-components-___loading__spinnerDark___2888d",
	"spin": "src-components-styles-components-___loading__spin___3biPD",
	"loader": "src-components-styles-components-___loading__loader___1g3na",
	"loadingPanel": "src-components-styles-components-___loading__loadingPanel___3ji8U"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/sass-loader!./src/components/styles/components/loading.scss
 ** module id = 913
 ** module chunks = 0
 **/